/**
 * The unsubscribe page (spec section 17, CAN-SPAM).
 *
 * The person reading this clicked a link in an email to make something stop.
 * The page has one job and should be over in one line of text: no offer to stay
 * subscribed, no "are you sure", no preference centre, no survey. Anything that
 * looks like an attempt to keep them is the opposite of what the link promised.
 *
 * The confirmation deliberately does not name the address. The token in the URL
 * is encrypted and the page never learns what it decoded to, so nothing here
 * can echo an email address into a screenshot, a browser history entry, or a
 * shared link (spec section 19).
 */

export const unsubscribeContent = {
  path: '/unsubscribe',

  heading: 'Email preferences',

  /** While the request is in flight. Usually invisible. */
  workingHeadline: 'One moment.',
  workingBody: 'Recording your request.',

  doneHeadline: 'Done.',
  doneBody: [
    "You won't receive further email from My Herd Book.",
    "Your early access record is unchanged. This stops email, it doesn't remove anything you submitted. To have your information removed as well, use the contact address in the footer and say so.",
  ],

  /**
   * Shown for an absent, malformed, expired-looking, or tampered token. One
   * message for all of them: the page cannot tell them apart and neither
   * should anyone reading it.
   */
  errorHeadline: "That link didn't work.",
  errorBody: [
    'Try the link in the original email again. Some mail clients wrap a long link across two lines, so copying the whole thing into the address bar can also work.',
    "If it still doesn't work, use the contact address in the footer and we'll take care of it.",
  ],

  backLinkLabel: 'Back to the homepage',
} as const;
